// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaBrowserList_container__C_oX_"};